import React from 'react'
import DoctorHome from '../../components/DoctorHome/DoctorHome'

function DoctorHomePage() {
  return (
    <DoctorHome/>
  )
}

export default DoctorHomePage